import { ConfigClientModule } from '../models/ConfigClientModule'
import { UpdateConfigClientModule } from '../models/UpdateConfigClientModule'
import { ConfigClientModuleRepository } from '../repositories/ConfigClientModuleRepository'

export function ConfigFoodModuleCase(
  configClientRepository: ConfigClientModuleRepository
) {
  return {
    async foodConfig(patientId: string): Promise<ConfigClientModule> {
      return await configClientRepository.foodConfig(patientId)
    },
    async updateFoodConfig(
      config: UpdateConfigClientModule
    ): Promise<ConfigClientModule> {
      return await configClientRepository.updateFoodConfig(config)
    }
  }
}
